import {Component, Injector, OnInit} from '@angular/core';
import {
    CircuitStatus,
    CircuitUtils,
    DefaultState,
    DialogService,
    PesCircuitStatusConfig,
    PesMessage,
    PesMessageType,
    PesTaskComponent
} from '@pes/ui';
import {interval} from 'rxjs/observable/interval';
import {LbpaCircuitViewUtils} from '../../utils/lbpa-circuit-view.utils';
import {DeviceDetectorService} from 'ngx-device-detector';

/**
 * The default implementation of the TaskComponent interface.
 */
@Component({
    selector: 'lbpa-task',
    templateUrl: 'lbpa-task.component.html'
})
export class LbpaTaskComponent extends PesTaskComponent implements OnInit {

    public isMobile: boolean = false;
    protected dialogService: DialogService = null;

    constructor(protected injector: Injector, private readonly deviceService: DeviceDetectorService) {
        super(injector);
        this.dialogService = injector.get(DialogService);
    }

    public ngOnInit(): void {
        super.ngOnInit();
        this.getWorkflowStatus();
        this.isMobile = this.deviceService.isMobile();
    }

    protected onFinished(messageConfig: PesMessage): void {
        if (this.task.data.context && this.task.data.context.redirectUrl) {
            this.state.go(DefaultState.MESSAGE, {...messageConfig, redirection: true, contractType: this.task.data.context.contractType});
            const redirectUrl: string = this.task.data.context.redirectUrl;
            setTimeout(() => {
                this.externalRedirect(redirectUrl, messageConfig.type);
            }, 2000);
        } else {
            this.state.go(DefaultState.MESSAGE, messageConfig);
        }
    }

    private getWorkflowStatus() {
        interval(5000)
            .switchMap(() => this._dossierService.get(this.task.dossierReference)
                .map(CircuitUtils.fromDossier.bind(this))
                .map(LbpaCircuitViewUtils.resolveStartedStatus.bind(this))
                .map((status: PesCircuitStatusConfig) => status.key)
                .filter(asyncStatus => asyncStatus !== CircuitStatus.STARTED))
            .subscribe(() => this.state.go(DefaultState.MESSAGE, {
                message: 'circuit.task.task_successfully_submitted',
                type: PesMessageType.SUCCESS
            }));
    }

    private externalRedirect(url: string, action: string): void {
        window.location.href = `${url}?action=${action}`;
    }
}



// WEBPACK FOOTER //
// ./src/app/component/task/lbpa-task.component.ts